import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { StreamrLogo } from '../shared/Logo';
export const PoweredByLink = () => {
    return (_jsx(Link, { href: "https://streamr.network", target: "_blank", children: _jsxs(Content, { children: [_jsx("div", { children: "Powered by" }), _jsx(StreamrLogo, {}), _jsx("div", { children: "Streamr" })] }) }));
};
const Link = styled.a `
    color: inherit;
    
    &:link,
    &:hover,
    &:visited,
    &:active {
        text-decoration: none;
    }
`;
const Content = styled.div `
    align-items: center;
    color: #ffffff;
    display: flex;
    gap: 0.5rem;
    font-weight: 600;

    > div {
        letter-spacing: -0.03em;
    }
`;
